import { api } from "../../../api/apiSlice";

// Global/shared master (handoff §9.x, added to the API 2026-08-12 -
// Batch47_AreaMaster.sql, src/Masters/Areas/) - a straight structural clone
// of Departments/Holidays. Keyed by areaId (an int PK), unlike Department's
// string code. List-only starts empty by design - the real legacy
// area_master rows (80, synced per-branch) are deliberately not surfaced
// here, only fresh API-managed rows going forward (same "clean shared list"
// precedent as Department/Designation). Not yet wired into any free-text
// Area field elsewhere (Guard Assignments' assignmentArea, Sales Enquiry's
// area) - that link was explicitly deferred, this is master-list CRUD only.
export const areasApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAreas: builder.query({
      query: () => ({ url: "/masters/areas" }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((a) => ({ type: "HrAreas", id: a.areaId })),
              { type: "HrAreas", id: "LIST" },
            ]
          : [{ type: "HrAreas", id: "LIST" }],
    }),
    createArea: builder.mutation({
      query: (body) => ({ url: "/masters/areas", method: "POST", data: body }),
      invalidatesTags: [{ type: "HrAreas", id: "LIST" }],
    }),
    updateArea: builder.mutation({
      query: ({ areaId, ...body }) => ({
        url: `/masters/areas/${areaId}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: [{ type: "HrAreas", id: "LIST" }],
    }),
    deleteArea: builder.mutation({
      query: (areaId) => ({ url: `/masters/areas/${areaId}`, method: "DELETE" }),
      invalidatesTags: [{ type: "HrAreas", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAreasQuery,
  useCreateAreaMutation,
  useUpdateAreaMutation,
  useDeleteAreaMutation,
} = areasApi;
